<template>
    <div class="mobile-page-on-desktop">
        <div class="locker-selection multirent-mode">
            <div class="step-counter radius-anchor last-step">
                <div class="step-counter-inner radius-anchor" :style="'width: ' + (step / total_steps) * 100 + '%;'"></div>
            </div>

            <div class="overflow-stretcher" :class="'step-' + step">
                <button
                    @click="instructionNavigator()"
                    class="btn btn-primary btn-locker-instructions"
                    v-if="step > increaser"
                    :class="{
                        'instructions-active': step >= steps_before_instructions + increaser && step < total_steps - (steps_after_instructions - 1),
                    }"
                >
                    <template v-if="step >= steps_before_instructions + increaser && step < total_steps - (steps_after_instructions - 1)">
                        {{ $t('lockerflow.confirmation.instructions.skip') }}
                        <svg class="cancel" fill="currentColor" struk viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M16 8L8 16M8.00001 8L16 16"
                                stroke="currentColor"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </template>

                    <template v-else>
                        {{ $t('lockerflow.confirmation.instructions.view') }}

                        <svg
                            fill="currentColor"
                            version="1.1"
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            viewBox="0 0 512 512"
                            xml:space="preserve"
                        >
                            <g>
                                <g>
                                    <path
                                        d="M256,0C114.837,0,0,114.843,0,256s114.837,256,256,256s256-114.843,256-256S397.163,0,256,0z M289.391,389.565
                                        c0,18.442-14.949,33.391-33.391,33.391s-33.391-14.949-33.391-33.391V222.609c0-18.442,14.949-33.391,33.391-33.391
                                        s33.391,14.949,33.391,33.391V389.565z M256,155.826c-18.442,0-33.391-14.949-33.391-33.391S237.558,89.044,256,89.044
                                        s33.391,14.949,33.391,33.391S274.442,155.826,256,155.826z"
                                    />
                                </g>
                            </g>
                        </svg>
                    </template>
                </button>

                <!-- {{ transaction.relationships }} -->
                <transition-group :name="direction" tag="div" class="locker-pages" id="locker-flow-pages">
                    <template v-if="instructionMode == 'event'">
                        <section v-if="step == 0 + increaser" class="centered-titles ccss-paymentSuccesfull">
                            <h2>{{ $t('paymentstatus.success.title') }}</h2>

                            <svg
                                class="payment-succesfull"
                                width="121"
                                height="120"
                                viewBox="0 0 121 120"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M87.0228 40.9616C88.8539 42.7927 88.8539 45.7608 87.0228 47.5909L55.5763 79.0384C53.7452 80.8685 50.778 80.8685 48.947 79.0384L33.9772 64.0677C32.1461 62.2375 32.1461 59.2694 33.9772 57.4393C35.8073 55.6082 38.7755 55.6082 40.6056 57.4393L52.2612 69.0948L80.3935 40.9616C82.2245 39.1315 85.1927 39.1315 87.0228 40.9616ZM120.5 60C120.5 93.165 93.6604 120 60.5 120C27.335 120 0.5 93.1604 0.5 60C0.5 26.835 27.3396 0 60.5 0C93.665 0 120.5 26.8396 120.5 60ZM111.125 60C111.125 32.0169 88.4794 9.375 60.5 9.375C32.5169 9.375 9.875 32.0206 9.875 60C9.875 87.9831 32.5206 110.625 60.5 110.625C88.4831 110.625 111.125 87.9794 111.125 60Z"
                                    fill="#02A388"
                                />
                            </svg>

                            <div class="locker-products">
                                <div class="option-list">
                                    <div
                                        class="locker-item bought radius-anchor active"
                                        v-for="(ticket, index) in this.transaction.relationships.tickets"
                                        :key="index"
                                    >
                                        <div class="product-content">
                                            <div class="name">{{ $t('locker.locker_number') }}</div>
                                            <div class="price">{{ ticket.attributes.description }}</div>
                                            <div class="price text-sm mt-1">
                                                {{ $t('lockers.locker') }}

                                                {{ ticket.attributes.details.type }}
                                            </div>
                                            <div class="price locker-color lowercase text-sm">
                                                {{ ticket.attributes.details.cabinet_color }}
                                                <span class="" :style="{ 'background-color': ticket.attributes.details.cabinet_color }"></span>
                                            </div>
                                        </div>
                                        <div class="product-content">
                                            <div class="name">{{ $t('fields.pincode') }}</div>
                                            <div class="price">{{ ticket.attributes.pincode }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section v-if="step == 1 + increaser" class="ccss-lockerflow ccss-step-1">
                            <h2>{{ $t('lockerflow.confirmation.your_locker_and_pin') }}</h2>

                            <p>{{ $t('lockerflow.confirmation.your_locker_and_pin.description') }}</p>

                            <div class="locker-products">
                                <div class="option-list">
                                    <div
                                        class="locker-item bought radius-anchor active"
                                        v-for="(ticket, index) in this.transaction.relationships.tickets"
                                        :key="index"
                                    >
                                        <div class="product-content">
                                            <div class="name">{{ $t('locker.locker_number') }}</div>
                                            <div class="price">{{ ticket.attributes.description }}</div>
                                            <div class="price text-sm mt-1">
                                                {{ $t('lockers.locker') }}

                                                {{ ticket.attributes.details.type }}
                                            </div>
                                            <div class="price locker-color lowercase text-sm">
                                                {{ ticket.attributes.details.cabinet_color }}
                                                <span class="" :style="{ 'background-color': ticket.attributes.details.cabinet_color }"></span>
                                            </div>
                                        </div>
                                        <div class="product-content">
                                            <div class="name">{{ $t('fields.pincode') }}</div>
                                            <div class="price">{{ ticket.attributes.pincode }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- <a href="#" class="btn btn-underline centered-link">{{ $t('lockerflow.problem') }}</a> -->
                        </section>
                        <section v-if="step == 2 + increaser" class="instruction-page ccss-step-2">
                            <h2>{{ $t('lockerflow.confirmation.event.step-1.title') }}</h2>

                            <p>{{ $t('lockerflow.confirmation.event.step-1.description') }}</p>

                            <LockerInstructions_1 />

                            <div class="locker-products">
                                <div class="option-list">
                                    <div
                                        class="locker-item bought radius-anchor active"
                                        v-for="(ticket, index) in transaction.relationships.tickets"
                                        :key="index"
                                    >
                                        <div class="product-content">
                                            <div class="name">{{ $t('locker.locker_number') }}</div>
                                            <div class="price text-sm locker-color">
                                                {{ ticket.attributes.details.type }}
                                                <span class="" :style="{ 'background-color': ticket.attributes.details.cabinet_color }"></span>
                                            </div>
                                        </div>
                                        <div class="product-content">
                                            <div class="price">{{ ticket.attributes.description }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section v-else-if="step == 3 + increaser" class="instruction-page ccss-step-3">
                            <h2>{{ $t('lockerflow.confirmation.event.step-2.title') }}</h2>

                            <p>{{ $t('lockerflow.confirmation.event.step-2.description') }}</p>

                            <!-- <LockerInstructions_2 /> -->
                            <LockerInstructions_2 :locker_number="transaction.relationships.tickets[0].attributes.description" />

                            <div class="locker-products">
                                <div class="option-list">
                                    <div
                                        class="locker-item bought radius-anchor active"
                                        v-for="(ticket, index) in transaction.relationships.tickets"
                                        :key="index"
                                    >
                                        <div class="product-content">
                                            <div class="name">{{ $t('locker.locker_number') }}</div>
                                            <div class="price text-sm locker-color">
                                                {{ ticket.attributes.details.type }}
                                                <span class="" :style="{ 'background-color': ticket.attributes.details.cabinet_color }"></span>
                                            </div>
                                        </div>
                                        <div class="product-content">
                                            <div class="price">{{ ticket.attributes.description }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section v-else-if="step == 4 + increaser" class="instruction-page ccss-step-4">
                            <h2>{{ $t('lockerflow.confirmation.event.step-3.title') }}</h2>

                            <p>{{ $t('lockerflow.confirmation.event.step-3.description') }}</p>

                            <LockerInstructions_3 />
                        </section>

                        <section v-else-if="step == 5 + increaser" class="instruction-page ccss-step-5">
                            <h2>{{ $t('lockerflow.confirmation.event.step-4.title') }}</h2>

                            <div class="description-steps">
                                <ul>
                                    <li>{{ $t('lockerflow.confirmation.event.step-4.description-step-1') }}</li>
                                    <li>{{ $t('lockerflow.confirmation.event.step-4.description-step-2') }}</li>
                                </ul>
                            </div>

                            <LockerInstructions_4 />

                            <div class="locker-products mb-8 ccss-locker-products">
                                <div class="option-list">
                                    <!-- <h2>Locker(s)</h2> -->
                                    <div
                                        class="locker-item bought radius-anchor active"
                                        v-for="(ticket, index) in transaction.relationships.tickets"
                                        :key="index"
                                    >
                                        <div class="product-content ccss-locker-number">
                                            <div class="name">{{ $t('locker.locker_number') }}</div>
                                            <div class="price locker-color">
                                                {{ ticket.attributes.description }}
                                                <span class="" :style="{ 'background-color': ticket.attributes.details.cabinet_color }"></span>
                                            </div>
                                        </div>
                                        <div class="product-content ccss-pincode">
                                            <div class="name">{{ $t('fields.pincode') }}</div>
                                            <div class="price">{{ ticket.attributes.pincode }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section v-else-if="step == 6 + increaser" class="instruction-page ccss-step-6">
                            <h2>{{ $t('lockerflow.confirmation.event.step-5.title') }}</h2>

                            <p>{{ $t('lockerflow.confirmation.event.step-5.description') }}</p>

                            <div class="description-steps">
                                <ul>
                                    <li>{{ $t('lockerflow.confirmation.event.step-5.description-step-1') }}</li>
                                    <li>{{ $t('lockerflow.confirmation.event.step-5.description-step-2') }}</li>
                                    <li>{{ $t('lockerflow.confirmation.event.step-5.description-step-3') }}</li>
                                </ul>
                            </div>

                            <LockerInstructions_6 />
                        </section>

                        <section v-else-if="step == 7 + increaser" class="instruction-page ccss-step-7">
                            <h2>{{ $t('lockerflow.confirmation.event.step-6.title') }}</h2>

                            <p>{{ $t('lockerflow.confirmation.event.step-6.description') }}</p>
                        </section>
                    </template>

                    <template v-else-if="instructionMode == 'coinlock'">
                        <section v-if="step == 0 + increaser" class="centered-titles">
                            <h2>{{ $t('paymentstatus.success.title') }}</h2>

                            <svg
                                class="payment-succesfull"
                                width="121"
                                height="120"
                                viewBox="0 0 121 120"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M87.0228 40.9616C88.8539 42.7927 88.8539 45.7608 87.0228 47.5909L55.5763 79.0384C53.7452 80.8685 50.778 80.8685 48.947 79.0384L33.9772 64.0677C32.1461 62.2375 32.1461 59.2694 33.9772 57.4393C35.8073 55.6082 38.7755 55.6082 40.6056 57.4393L52.2612 69.0948L80.3935 40.9616C82.2245 39.1315 85.1927 39.1315 87.0228 40.9616ZM120.5 60C120.5 93.165 93.6604 120 60.5 120C27.335 120 0.5 93.1604 0.5 60C0.5 26.835 27.3396 0 60.5 0C93.665 0 120.5 26.8396 120.5 60ZM111.125 60C111.125 32.0169 88.4794 9.375 60.5 9.375C32.5169 9.375 9.875 32.0206 9.875 60C9.875 87.9831 32.5206 110.625 60.5 110.625C88.4831 110.625 111.125 87.9794 111.125 60Z"
                                    fill="#02A388"
                                />
                            </svg>

                            <div class="locker-products">
                                <div class="option-list">
                                    <div
                                        class="locker-item bought radius-anchor active"
                                        v-for="(line, index) in this.transaction.relationships.lines"
                                        :key="index"
                                    >
                                        <div class="product-content">
                                            <div class="name">
                                                {{ line.attributes.description }}
                                            </div>
                                            <div class="price">
                                                {{ $n(line.attributes.total, currency) }}
                                            </div>
                                        </div>
                                        <!--
                                        <div class="product-content" v-if="transaction.relationships.tickets[0]">
                                            <div class="name">Pincode</div>
                                            <div class="price">{{transaction?.relationships?.tickets[0]?.attributes.pincode}}</div>
                                        </div> -->
                                    </div>
                                </div>
                            </div>

                            <!-- <a href="#" class="btn btn-underline centered-link">{{ $t('lockerflow.problem') }}</a> -->
                        </section>

                        <section v-if="step == 1 + increaser" class="ccss-confirmation ccss-step-1">
                            <h2>{{ $t('lockerflow.confirmation.your_locker_and_pin') }}</h2>

                            <div class="locker-products">
                                <div class="option-list">
                                    <div
                                        class="locker-item bought radius-anchor active"
                                        v-for="(line, index) in this.transaction.relationships.lines"
                                        :key="index"
                                    >
                                        <div class="product-content" v-if="transaction.relationships.tickets[0]">
                                            <div class="name">{{ $t('lockers.locker') }}</div>
                                            <div class="price">
                                                {{ transaction.relationships.tickets[0].attributes.description }}
                                            </div>
                                        </div>

                                        <div class="product-content" v-if="transaction.relationships.tickets[0]">
                                            <div class="name">{{ $t('fields.pincode') }}</div>
                                            <div class="price">{{ transaction?.relationships?.tickets[0]?.attributes.pincode }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- <a href="#" class="btn btn-underline centered-link">{{ $t('lockerflow.problem') }}</a> -->
                        </section>

                        <section v-if="step == 2 + increaser" class="instruction-page centered-titles ccss-confirmation ccss-step-2">
                            <h2>{{ $t('lockerflow.confirmation.coinlock.disclaimer.title') }}</h2>

                            <p>{{ $t('lockerflow.confirmation.coinlock.disclaimer.description') }}</p>

                            <LockerInstructionsCoinlock_1 />
                        </section>

                        <section v-else-if="step == 3 + increaser" class="instruction-page ccss-confirmation ccss-step-3">
                            <h2>{{ $t('lockerflow.confirmation.coinlock.step-1.title') }}</h2>

                            <p>{{ $t('lockerflow.confirmation.coinlock.step-1.description') }}</p>
                        </section>

                        <section v-else-if="step == 4 + increaser" class="instruction-page ccss-confirmation ccss-step-4">
                            <h2>{{ $t('lockerflow.confirmation.coinlock.step-2.title') }}</h2>

                            <p>{{ $t('lockerflow.confirmation.coinlock.step-2.description') }}</p>
                            <LockerInstructions_6 />

                            <div class="locker-products ccss-locker-products">
                                <div class="option-list">
                                    <div
                                        class="locker-item bought radius-anchor active"
                                        v-for="(ticket, index) in this.transaction.relationships.tickets"
                                        :key="index"
                                    >
                                        <div class="product-content ccss-locker-number">
                                            <div class="name">{{ $t('locker.locker_number') }}</div>
                                            <div class="price">{{ ticket.attributes.description }}</div>
                                        </div>
                                        <div class="product-content ccss-pincode">
                                            <div class="name">{{ $t('fields.pincode') }}</div>
                                            <div class="price">{{ ticket.attributes.pincode }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section v-else-if="step == 5 + increaser" class="instruction-page ccss-step-5" >
                            <h2>{{ $t('lockerflow.confirmation.coinlock.step-3.title') }}</h2>

                            <p>{{ $t('lockerflow.confirmation.coinlock.step-3.description') }}</p>
                        </section>

                        <section v-if="step == 6 + increaser" class="instruction-page centered-titles ccss-step-6">
                            <h2>{{ $t('lockerflow.confirmation.coinlock.disclaimer.title') }}</h2>

                            <p>{{ $t('lockerflow.confirmation.coinlock.disclaimer.description') }}</p>
                            <LockerInstructionsCoinlock_1 />
                        </section>
                    </template>

                    <template v-else-if="instructionMode == 'multirent'">
                        <section v-if="step == 0 + increaser" class="centered-titles ccss-multirent step-0">
                            <h2>{{ $t('paymentstatus.success.title') }}</h2>

                            <svg
                                class="payment-succesfull"
                                width="121"
                                height="120"
                                viewBox="0 0 121 120"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M87.0228 40.9616C88.8539 42.7927 88.8539 45.7608 87.0228 47.5909L55.5763 79.0384C53.7452 80.8685 50.778 80.8685 48.947 79.0384L33.9772 64.0677C32.1461 62.2375 32.1461 59.2694 33.9772 57.4393C35.8073 55.6082 38.7755 55.6082 40.6056 57.4393L52.2612 69.0948L80.3935 40.9616C82.2245 39.1315 85.1927 39.1315 87.0228 40.9616ZM120.5 60C120.5 93.165 93.6604 120 60.5 120C27.335 120 0.5 93.1604 0.5 60C0.5 26.835 27.3396 0 60.5 0C93.665 0 120.5 26.8396 120.5 60ZM111.125 60C111.125 32.0169 88.4794 9.375 60.5 9.375C32.5169 9.375 9.875 32.0206 9.875 60C9.875 87.9831 32.5206 110.625 60.5 110.625C88.4831 110.625 111.125 87.9794 111.125 60Z"
                                    fill="#02A388"
                                />
                            </svg>

                            <div class="locker-products ccss-locker-products">
                                <div class="option-list">
                                    <div
                                        class="locker-item bought radius-anchor active"
                                        v-for="(line, index) in this.transaction.relationships.lines"
                                        :key="index"
                                    >
                                        <div class="product-content">
                                            <div class="name">
                                                {{ line.attributes.description }}
                                            </div>
                                            <div class="price">
                                                {{ $n(line.attributes.total, currency) }}
                                            </div>
                                        </div>
                                        <!--
                                        <div class="product-content" v-if="transaction.relationships.tickets[0]">
                                            <div class="name">Pincode</div>
                                            <div class="price">{{transaction?.relationships?.tickets[0]?.attributes.pincode}}</div>
                                        </div> -->
                                    </div>
                                </div>
                            </div>

                            <!-- <a href="#" class="btn btn-underline centered-link">{{ $t('lockerflow.problem') }}</a> -->
                        </section>

                        <section v-if="step == 1 + increaser" class="ccss-confirmation ccss-confirmation ccss-step-1">
                            <h2>{{ $t('lockerflow.confirmation.your_locker_and_pin') }}</h2>

                            <div class="locker-products ccss-locker-products">
                                <div class="option-list">
                                    <div
                                        class="locker-item bought radius-anchor active"
                                        v-for="(line, index) in this.transaction.relationships.lines"
                                        :key="index"
                                    >
                                        <div class="product-content" v-if="transaction.relationships.tickets[0]">
                                            <div class="name">{{ $t('lockers.locker') }}</div>
                                            <div class="price">
                                                {{ transaction.relationships.tickets[0].attributes.description }}
                                            </div>
                                        </div>

                                        <div class="product-content" v-if="transaction.relationships.tickets[0]">
                                            <div class="name">{{ $t('fields.pincode') }}</div>
                                            <div class="price">{{ transaction?.relationships?.tickets[0]?.attributes.pincode }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- <a href="#" class="btn btn-underline centered-link">{{ $t('lockerflow.problem') }}</a> -->
                        </section>

                        <section v-if="step == 2 + increaser" class="instruction-page centered-titles ccss-confirmation ccss-step-2">
                            <h2>{{ $t('lockerflow.confirmation.multirent.disclaimer.title') }}</h2>

                            <p>{{ $t('lockerflow.confirmation.multirent.disclaimer.description') }}</p>

                            <!-- <LockerInstructionsCoinlock_1 /> -->
                        </section>

                        <section v-else-if="step == 3 + increaser" class="instruction-page ccss-step-3">
                            <h2>{{ $t('lockerflow.confirmation.multirent.step-1.title') }}</h2>

                            <p>{{ $t('lockerflow.confirmation.multirent.step-1.description') }}</p>
                        </section>

                        <section v-else-if="step == 4 + increaser" class="instruction-page ccss-step-4">
                            <h2>{{ $t('lockerflow.confirmation.multirent.step-2.title') }}</h2>

                            <p>{{ $t('lockerflow.confirmation.multirent.step-2.description') }}</p>

                            <LockerInstructions_6 />

                            <div class="locker-products ccss-locker-products">
                                <div class="option-list">
                                    <div
                                        class="locker-item bought radius-anchor active"
                                        v-for="(ticket, index) in this.transaction.relationships.tickets"
                                        :key="index"
                                    >
                                        <div class="product-content ccss-locker-number">
                                            <div class="name">{{ $t('locker.locker_number') }}</div>
                                            <div class="price">{{ ticket.attributes.description }}</div>
                                        </div>
                                        <div class="product-content ccss-pincode">
                                            <div class="name">{{ $t('fields.pincode') }}</div>
                                            <div class="price">{{ ticket.attributes.pincode }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section v-else-if="step == 5 + increaser" class="instruction-page ccss-step-5">
                            <h2>{{ $t('lockerflow.confirmation.multirent.step-3.title') }}</h2>

                            <p>{{ $t('lockerflow.confirmation.multirent.step-3.description') }}</p>
                        </section>

                        <section v-if="step == 6 + increaser" class="instruction-page centered-titles ccss-step-6">
                            <h2>{{ $t('lockerflow.confirmation.multirent.disclaimer.title') }}</h2>

                            <p>{{ $t('lockerflow.confirmation.multirent.disclaimer.description') }}</p>
                            <!-- <LockerInstructionsCoinlock_1 /> -->
                        </section>
                    </template>

                    <section v-if="step == total_steps - steps_after_instructions + 1" class="centered-section share-code">
                        <h2>{{ $t('lockerflow.confirmation.share_lockers') }}</h2>

                        <template v-if="this.instructionMode == 'event'">
                            <template v-for="(ticket, index) in transaction.relationships.tickets" :key="index">
                                <div class="share-locker-title">
                                    <h3>{{ $t('lockerflow.confirmation.share_locker') }} {{ ticket.attributes.description }}</h3>
                                    <span>{{ ticket.attributes.details.type }}</span>
                                </div>

                                <div class="confirmation-actions">
                                    <a
                                        :href="'whatsapp://send?text=' + getShareLockerText(ticket)"
                                        data-action="share/whatsapp/share"
                                        class="btn btn-secondary"
                                    >
                                        <svg
                                            class="whatsapp-svg"
                                            width="44"
                                            height="41"
                                            viewBox="0 0 44 41"
                                            fill="currentColor"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <g clip-path="url(#clip0_1310_2455)">
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M37.5858 5.88673C33.4486 2.02338 27.9456 -0.101318 22.0844 -0.101318C10.0106 -0.101382 0.183494 9.05642 0.183494 20.3154C0.183494 23.9118 1.19446 27.4295 3.10998 30.5204L0 41.1022L11.6159 38.2617C14.8193 39.8877 18.4231 40.7495 22.0812 40.7495H22.0901C34.1648 40.7495 43.9999 31.5918 43.9999 20.3335C43.9999 14.8766 41.7198 9.75175 37.5825 5.88981L37.5858 5.8868L37.5858 5.88673ZM22.0909 37.3046C18.8185 37.3046 15.6134 36.4829 12.8169 34.937L12.1502 34.5662L5.25697 36.2483L7.09782 29.9878L6.66662 29.3446C4.83388 26.6478 3.87743 23.5266 3.87743 20.3162C3.87743 10.9578 12.0471 3.34217 22.1007 3.34217C26.9622 3.34217 31.542 5.1135 34.9777 8.31483C38.415 11.5261 40.3054 15.7837 40.3054 20.3214C40.2973 29.6865 32.1276 37.3022 22.0894 37.3022L22.091 37.3045L22.0909 37.3046ZM32.0746 24.5904C31.5306 24.3324 28.8355 23.1021 28.3353 22.9318C27.8351 22.7616 27.4704 22.6738 27.0994 23.1898C26.7372 23.6968 25.684 24.8484 25.3633 25.1927C25.0425 25.531 24.725 25.5794 24.181 25.3214C23.6369 25.0633 21.8659 24.5253 19.7766 22.7865C18.1518 21.4352 17.0499 19.7615 16.7291 19.2545C16.4084 18.7475 16.6933 18.466 16.9719 18.2172C17.2236 17.9901 17.5167 17.6224 17.7928 17.3235C18.0698 17.0246 18.1558 16.8158 18.3377 16.4708C18.5204 16.1326 18.4311 15.8337 18.2939 15.5771C18.1558 15.3199 17.058 12.8086 16.6105 11.7856C16.1712 10.786 15.7125 10.9252 15.3755 10.9079C15.0547 10.8927 14.6917 10.8927 14.3305 10.8927C13.969 10.8927 13.3714 11.0206 12.8712 11.529C12.371 12.036 10.9532 13.2754 10.9532 15.786C10.9532 18.2973 12.9135 20.7194 13.1887 21.0652C13.4656 21.4026 17.0499 26.5607 22.5407 28.7679C23.8456 29.2908 24.8647 29.6048 25.6589 29.8476C26.9719 30.2336 28.1631 30.1776 29.105 30.0482C30.1583 29.9036 32.3442 28.8163 32.803 27.6246C33.261 26.4321 33.261 25.4122 33.1237 25.2011C32.9938 24.974 32.6316 24.8485 32.0787 24.5873L32.0746 24.5904Z"
                                                    fill="#252525"
                                                />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_1310_2455">
                                                    <rect width="44" height="41" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        Whatsapp
                                    </a>

                                    <a :href="'sms:&body=' + getShareLockerText(ticket)" class="btn btn-secondary">
                                        <svg
                                            class="mail-svg"
                                            width="47"
                                            height="45"
                                            viewBox="0 0 47 45"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <g clip-path="url(#clip0_1310_2461)">
                                                <path
                                                    d="M23.5 2.21509e-05C28.9389 -0.00146638 34.2101 1.80282 38.4153 5.10543C42.6205 8.40803 45.4995 13.0046 46.5617 18.1118C47.6239 23.219 46.8036 28.5209 44.2405 33.1139C41.6774 37.7069 37.5301 41.3069 32.5055 43.3003C27.4808 45.2937 21.8897 45.5573 16.6848 44.0461C11.4799 42.5349 6.98341 39.3424 3.96147 35.0127C0.939534 30.683 -0.420818 25.4839 0.11223 20.3015C0.645278 15.1191 3.03874 10.274 6.88476 6.59182C9.06368 4.49866 11.6534 2.83869 14.5049 1.70741C17.3564 0.576124 20.4134 -0.00413226 23.5 2.21509e-05ZM12.3237 29.0735L19.9276 21.7749L12.3237 15.8386V29.0735ZM20.7652 22.4268L12.9242 29.9524H34.0069L26.5178 22.4268L24.0469 24.4446C23.9499 24.5208 23.8282 24.5624 23.7027 24.5624C23.5772 24.5624 23.4556 24.5208 23.3585 24.4446L20.7652 22.4195V22.4268ZM27.3363 21.7603L34.6763 29.1321V15.7727L27.3363 21.7603ZM13.0045 15.0476L23.6759 23.3826L33.9075 15.0476H13.0045ZM38.0192 8.58767C34.6575 5.37001 30.2346 3.36783 25.504 2.92225C20.7734 2.47667 16.0278 3.61526 12.0757 6.14403C8.12352 8.6728 5.20936 12.4353 3.82968 16.7905C2.45 21.1458 2.69013 25.8243 4.50918 30.029C6.32823 34.2337 9.61365 37.7046 13.8057 39.8501C17.9978 41.9957 22.8371 42.6833 27.4993 41.7957C32.1615 40.9082 36.358 38.5005 39.374 34.9827C42.39 31.465 44.0388 27.0548 44.0395 22.5037C44.0433 19.9187 43.5134 17.3585 42.4802 14.9703C41.447 12.5821 39.9309 10.413 38.0192 8.58767Z"
                                                    fill="#252525"
                                                />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_1310_2461">
                                                    <rect width="47" height="45" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        Sms
                                    </a>

                                    <a :href="generateTikkieLink(ticket)" class="btn btn-secondary">
                                        <svg
                                            class="tikkie-svg"
                                            width="53"
                                            height="45"
                                            viewBox="0 0 53 45"
                                            fill="currentColor"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <g clip-path="url(#clip0_1311_2495)">
                                                <path
                                                    d="M29.1912 0.0263901C25.0376 0.227455 21.1229 1.50804 17.6789 3.78916C13.6677 6.44846 10.576 10.3644 8.94693 14.8525C8.04429 17.3394 7.60262 19.8623 7.60262 22.536C7.60262 25.7458 8.26874 28.8288 9.5865 31.7155C9.79888 32.1822 10.2261 33.0152 10.4385 33.3791L10.5784 33.6184L10.564 34.1929C10.5253 35.7439 10.2092 37.1155 9.59857 38.3697C8.89142 39.8203 7.69916 41.12 6.39588 41.8572C6.25107 41.9386 4.83436 42.5729 3.10631 43.3269C0.564913 44.4352 0.0798039 44.6554 0.137727 44.6674C0.239094 44.6913 6.98477 44.7463 7.47712 44.7272C9.15207 44.6626 10.9815 44.4184 12.5623 44.0522C14.6934 43.5567 16.5349 42.8099 17.9685 41.862L18.3523 41.6059L18.5598 41.7447C19.9596 42.6759 21.736 43.4969 23.5074 44.0307C26.9853 45.0791 31.0906 45.2658 34.735 44.5429C39.4195 43.6142 43.6697 41.2564 46.923 37.7857C50.0605 34.437 52.1072 30.2003 52.7443 25.7314C52.9229 24.4868 52.964 23.8979 52.964 22.5001C52.964 21.0783 52.9253 20.5086 52.7443 19.2447C52.1048 14.7567 50.0364 10.4913 46.8796 7.14501C44.5192 4.64368 41.6013 2.69767 38.3865 1.47692C35.4952 0.383038 32.2877 -0.124409 29.1912 0.0263901ZM31.2306 2.89634C32.6714 2.97054 33.912 3.15724 35.2732 3.50671C43.0711 5.50299 48.9093 12.0615 49.923 19.97C50.0219 20.7527 50.0581 21.2745 50.0726 22.1769C50.0871 23.0961 50.063 23.6753 49.9809 24.4868C49.3027 31.153 45.2022 37.0389 39.1468 40.0309C36.7768 41.2014 34.426 41.8405 31.665 42.0607C31.1558 42.1014 29.3143 42.1014 28.7688 42.0607C27.2049 41.9434 25.9137 41.728 24.6659 41.3713C22.6314 40.7921 20.9733 39.9806 19.2766 38.7336L18.9218 38.4727L18.6974 38.4511C18.4271 38.4272 18.193 38.4272 17.8671 38.4535L17.621 38.4727L17.3482 38.712C16.0763 39.8251 14.5727 40.5623 12.4054 41.1296C11.9831 41.2421 11.2011 41.4144 11.1601 41.4049C11.1384 41.4001 11.189 41.3115 11.2977 41.1583C12.3282 39.7102 13.0378 37.891 13.3202 35.9642C13.4239 35.2604 13.4481 34.9086 13.4601 33.8578L13.4722 32.8285L13.2526 32.4647C11.7924 30.0424 10.8994 27.3974 10.6098 24.6304C10.5229 23.8094 10.5109 23.5676 10.5109 22.524C10.5109 21.4493 10.5253 21.1788 10.6195 20.3099C11.0635 16.2886 12.8061 12.4301 15.5502 9.39501C16.0788 8.81097 16.9911 7.9349 17.592 7.43703C19.6073 5.76628 21.999 4.47852 24.4728 3.73171C26.6546 3.07107 29.0029 2.78144 31.2306 2.89634Z"
                                                    fill="#252525"
                                                />
                                                <path
                                                    d="M30.0961 10.654C27.7574 10.8383 25.8677 11.5875 24.142 13.0093C23.64 13.4234 22.9401 14.1463 22.5009 14.7088C21.6658 15.7811 21.0142 17.0785 20.6497 18.4069L20.5677 18.7061L20.1743 18.7205C19.8557 18.7301 19.7519 18.7444 19.6385 18.7851C19.2668 18.9192 19.0761 19.1226 18.982 19.4769C18.9386 19.6396 18.9337 20.0513 18.9723 20.2309C19.081 20.7311 19.4116 20.9849 20.0101 21.0303L20.2322 21.0471L20.2153 21.2625C20.2081 21.3822 20.2008 21.7508 20.2008 22.0859V22.6915H20.0922C19.9184 22.6915 19.6264 22.7609 19.4695 22.8375C19.2209 22.9644 19.0375 23.2013 18.9723 23.4838C18.9579 23.5412 18.9458 23.7016 18.9458 23.8404C18.9458 24.2641 19.0375 24.5298 19.2523 24.7309C19.4719 24.9319 19.6457 24.9894 20.1284 25.0109L20.4784 25.0253L20.5773 25.3963C20.9393 26.775 21.5234 28.0245 22.3198 29.1303C22.8025 29.7982 23.5917 30.6383 24.2144 31.1482C25.6866 32.3498 27.3857 33.0918 29.2755 33.3527C29.8306 33.4293 30.0019 33.4412 30.796 33.4532C31.8627 33.4724 32.4516 33.4221 33.3422 33.245C34.8289 32.9458 36.2239 32.2732 37.0372 31.4665C37.4765 31.0309 37.7154 30.6335 37.8361 30.1357C37.8892 29.913 37.894 29.3888 37.8458 29.1423C37.6792 28.3069 37.1845 27.62 36.5352 27.3255C36.2577 27.1987 36.0332 27.158 35.6736 27.1748C35.1523 27.1963 34.6938 27.3567 34.0035 27.7588C33.5208 28.0388 33.2384 28.1705 32.8692 28.2926C31.6793 28.6827 30.1274 28.6564 28.9617 28.2279C28.4718 28.0484 27.9433 27.7492 27.5499 27.4309C27.3206 27.2442 26.8789 26.7894 26.71 26.5644C26.4083 26.1623 26.0583 25.5495 25.899 25.1378L25.8484 25.0133H27.4992C28.4187 25.0133 29.2007 25.0037 29.2658 24.9918C29.623 24.9248 29.8668 24.75 30.0116 24.4556C30.1902 24.0918 30.1878 23.5676 30.0068 23.2373C29.9223 23.0841 29.7172 22.895 29.5555 22.8208C29.2755 22.6939 29.2441 22.6915 27.2264 22.6915H25.3584L25.3729 21.9902C25.3825 21.6072 25.397 21.2338 25.4043 21.1668L25.4188 21.0423L28.2473 21.0351C31.0615 21.0279 31.0735 21.0279 31.2232 20.9777C31.619 20.8436 31.8434 20.5971 31.9279 20.2069C31.9713 20.0035 31.9617 19.6301 31.9086 19.4625C31.7903 19.0819 31.5055 18.833 31.0904 18.7444C31.0011 18.7253 30.224 18.7181 28.4911 18.7181C27.1299 18.7181 26.0173 18.7109 26.0173 18.7013C26.0173 18.6654 26.3407 18.0742 26.4662 17.8851C27.002 17.0689 27.6681 16.4729 28.4911 16.0708C29.0317 15.8075 29.6061 15.6447 30.2843 15.5681C30.7381 15.5154 31.6552 15.5322 32.0389 15.6016C32.7437 15.7285 33.1805 15.8888 33.7911 16.2431C34.3945 16.5902 34.9158 16.8104 35.3261 16.8894C35.5698 16.9349 35.9922 16.9325 36.2094 16.8846C36.8249 16.7458 37.3631 16.2575 37.6503 15.5753C38.0123 14.7136 37.9592 13.8686 37.4982 13.1769C37.1434 12.6431 36.6438 12.2266 35.804 11.7646C34.7131 11.1638 33.6801 10.8479 32.2682 10.6851C31.8796 10.6396 30.5088 10.6205 30.0961 10.654Z"
                                                    fill="#252525"
                                                />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_1311_2495">
                                                    <rect width="53" height="45" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        Tikkie
                                    </a>
                                </div>
                            </template>
                        </template>
                    </section>

                    <section v-if="step == total_steps" class="centered-section share-code">
                        <h2>{{ $t('lockerflow.confirmation.thank_you') }}</h2>

                        <div>
                            <div class="py-2 sm:grid sm:grid-cols-4 sm:gap-4 sm:py-5">
                                <h4>{{ $t('fields.transactionnumber') }}</h4>
                                <span class="flex-grow">{{ transaction.attributes.transactionnumber }}</span>
                            </div>

                            <div class="py-2 sm:grid sm:grid-cols-4 sm:gap-4 sm:py-5">
                                <h4>{{ $t('locker.locker_information') }}</h4>
                                <span class="flex-grow">{{ transaction.relationships.tickets[0].attributes.description }}</span>
                            </div>

                            <div class="py-2 sm:grid sm:grid-cols-4 sm:gap-4 sm:py-5">
                                <h4>{{ $t('fields.location') }}</h4>
                                <span class="flex-grow"
                                    >{{ transaction.relationships.location.attributes.name }}
                                    <span v-if="transaction.relationships.area"> - {{ transaction.relationships.area?.attributes.name }} </span></span
                                >
                            </div>

                            <div class="py-2 sm:grid sm:grid-cols-4 sm:gap-4 sm:py-5">
                                <h4>{{ $t('fields.email') }}</h4>
                                <span class="flex-grow">{{ transaction.attributes.customer_email }}</span>
                            </div>

                            <div class="py-2 sm:grid sm:grid-cols-4 sm:gap-4 sm:py-5">
                                <h4>{{ $t('fields.date_and_time') }}</h4>
                                <span class="flex-grow">{{ transaction.attributes.timestamp }}</span>
                            </div>
                        </div>
                    </section>
                </transition-group>
            </div>
        </div>
        <div>
            <div class="prev-next-locker-area">
                <button v-if="this.step >= 1 + this.increaser" class="btn btn-empty prev-step" @click="previousStep()">
                    {{ $t('lockers.previous_step') }}
                </button>
                <button v-if="this.step < this.total_steps" class="btn btn-primary next-step" @click="nextStep()">
                    <!-- <span v-if="this.step == 0 + increaser"> {{ $t('lockerflow.confirmation.fetch_code') }} </span> -->
                    <!-- <span v-else> -->
                    <span>
                        {{ $t('lockers.next_step') }}
                    </span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
// components
import * as _applicationState from '../lib/application-state';
import * as _state from '../lib/state';

import LockerInstructionsCoinlock_1 from './locker-images/coinlock/LockerInstructionsCoinlock_1';
// import LockerInstructionsCoinlock_3 from './locker-images/coinlock/LockerInstructionsCoinlock_3';
// import LockerInstructionsCoinlock_4 from './locker-images/coinlock/LockerInstructionsCoinlock_4';
// import LockerInstructionsCoinlock_6 from './locker-images/coinlock/LockerInstructionsCoinlock_6';
import LockerInstructions_1 from './locker-images/event/LockerInstructions_1';
import LockerInstructions_2 from './locker-images/event/LockerInstructions_2';
import LockerInstructions_3 from './locker-images/event/LockerInstructions_3';
import LockerInstructions_4 from './locker-images/event/LockerInstructions_4';
import LockerInstructions_6 from './locker-images/event/LockerInstructions_6';

export default {
    name: 'LockerConfirmation',
    props: ['transaction'],
    components: {
        LockerInstructionsCoinlock_1,
        // LockerInstructionsCoinlock_3,
        // LockerInstructionsCoinlock_4,
        // LockerInstructionsCoinlock_6,
        LockerInstructions_1,
        LockerInstructions_2,
        LockerInstructions_3,
        LockerInstructions_4,
        LockerInstructions_6,
    },
    data() {
        return {
            step: 0,
            total_steps: 0,
            steps_before_instructions: 2,
            steps_after_instructions: 2,
            increaser: 0,
            instructionMode: null,
            total_instruction_steps: 0,
            // direction: 'pages-forward',
        };
    },
    async mounted() {
        this.increaser = this.applicationLockerFlowStep + 1;

        if (this.location.lockers.instruction_flow == 'multirent') {
            this.instructionMode = 'multirent';
            (this.steps_before_instructions = 2), (this.total_instruction_steps = 5);
            this.steps_after_instructions = 1;
        } else if (this.transaction.relationships.tickets[0].attributes.mode == 'coinlock') {
            this.instructionMode = 'coinlock';
            (this.steps_before_instructions = 2), (this.total_instruction_steps = 5);
            this.steps_after_instructions = 1;
        } else {
            this.instructionMode = 'event';
            this.total_instruction_steps = 5;
        }

        this.step = this.increaser;

        this.total_steps = this.increaser + this.steps_before_instructions + this.total_instruction_steps + this.steps_after_instructions - 1;
    },
    methods: {
        getTotalSteps() {
            // this.total_instruction_steps = this.$refs[this.instructionMode].getTotalSteps();
            return this.total_steps;
        },

        skipInstructions() {
            this.step = this.total_instruction_steps + 1 + this.increaser;
            this.$refs[this.instructionMode].resetSteps(this.total_instruction_steps);
        },

        instructionNavigator() {
            if (this.step < this.steps_before_instructions + this.increaser) {
                this.direction = 'pages-forward';
                this.step = this.steps_before_instructions + this.increaser;
            } else if (this.step >= this.total_steps - (this.steps_after_instructions - 1)) {
                this.direction = 'pages-back';
                this.step = this.steps_before_instructions + this.increaser;
            } else if (
                this.step >= this.steps_before_instructions + this.increaser &&
                this.step < this.total_steps - (this.steps_after_instructions - 1)
            ) {
                this.direction = 'pages-forward';
                this.step = this.total_steps - (this.steps_after_instructions - 1);
            }
        },

        previousStep() {
            this.direction = 'pages-back';
            this.step--;
            document.querySelector('.overflow-stretcher').scrollTop = 0;

            // if (this.step == (this.total_instruction_steps + 1)) {
            //     this.step = 0 + this.increaser;
            // } else if (this.step >= 1 + this.increaser) {
            //     this.step--;
            // }
        },

        nextStep() {
            this.direction = 'pages-forward';

            if (this.step == 0) {
                this.step = this.total_instruction_steps + 1;
                return;
            }

            if (this.firstLockerStep === false) {
                this.firstLockerStep = true;
                this.getTotalSteps();
                this.step++;
                return;
            }

            if (this.step < this.total_steps) {
                this.step++;
            }

            document.querySelector('.overflow-stretcher').scrollTop = 0;
        },

        processedPincode(pincode) {
            let pincodeArray = pincode.split('');

            if (pincodeArray.length == 7) {
                pincodeArray.splice(3, 0, '');
            }

            return pincodeArray;
        },

        getShareLockerText(ticket) {
            return (
                ' Locker: ' +
                ticket.attributes.description +
                ', Pincode: ' +
                ticket.attributes.pincode +
                ', Color:  ' +
                ticket.attributes.details.cabinet_color +
                ', Type: ' +
                ticket.attributes.details.type
            );
        },

        generateTikkieLink(transaction) {
            let total = transaction.attributes?.total ?? false;

            if (total) {
                total *= 100;

                let eventName = transaction.relationships.tickets[0].attributes.event;
                if (eventName) {
                    if (eventName.includes(' ')) {
                        eventName = eventName.replace(' ', '%20');
                    }

                    let tikkielink =
                        'tikkie://payment_request?clientId=elockerstikkie&totalAmountInCents=' +
                        total +
                        '&numberOfPersons=1&description=' +
                        'Locker:%20' +
                        eventName;

                    return tikkielink;
                }
            }

            return false;
        },
    },

    computed: {
        applicationLockerFlowStep() {
            return _applicationState.getLockerFlowStep();
        },

        config() {
            return _state.get('config/getConfig');
        },

        currency() {
            return this.config.settings.currency;
        },

        location() {
            return _state.get('location/getLocation');
        },
    },
};
</script>
